export default __webpack_public_path__ + "static/landing-section-3-img-3-cfad405aa4a6e177f3a875e3c1162461.png";